import React, { useState, useEffect } from "react";
import { Table, Tag, Button, Space } from "antd";
import { calculateTotals, formatPrice, getStatusColor } from "../../../lib/utils";
import { useSelector } from "react-redux";
import moment from "moment";
import { traerserialesPorFacturaCount } from "../../../services/seriales";

const InvoiceTable = ({ facturas, loading, showFacturaDetails }) => {
  const signoMoneda = useSelector(state => state.signoMoneda.signo_moneda);
  const [serialCounts, setSerialCounts] = useState({});
 
  useEffect(() => {
    const fetchSerialCounts = async () => {
      if (!facturas || facturas.length === 0) return;
      
      const counts = {};
      
      for (const factura of facturas) {
        try {
          const response = await traerserialesPorFacturaCount(factura.id);
          counts[factura.id] = response?.[0]?.countDistinct?.id || 0;
        } catch (error) {
          console.error(`Error fetching serial count for factura ${factura.id}:`, error);
          counts[factura.id] = 0;
        }
      }
      
      setSerialCounts(counts);
    };

    fetchSerialCounts();
  }, [facturas]);

  const columns = [
    {
      title: "Consecutivo",
      dataIndex: "consecutivo",
      key: "consecutivo",
    },
    {
      title: "Cliente",
      dataIndex: ["cliente", "first_name"],
      key: "cliente",
      render: (_, record) =>
        `${record.cliente?.first_name || ""} ${
          record.cliente?.last_name || ""
        }`,
    },
    {
      title: "Vendedor",
      dataIndex: ["vendedor_factura", "first_name"],
      key: "vendedor",
      render: (_, record) =>
        `${record.vendedor_factura?.first_name || ""} ${
          record.vendedor_factura?.last_name || ""
        }`,
    },
    {
      title: "Fecha",
      dataIndex: "fecha_facturacion",
      key: "fecha",
      render: (fecha) => fecha ? moment(fecha).format('DD/MM/YYYY HH:mm') : 'N/A',
    },
    {
      title: "Tipo",
      dataIndex: "estado",
      key: "estado",
      render: (estado) => (
        <Tag color={getStatusColor(estado)}>
          {estado?.toUpperCase() || "N/A"}
        </Tag>
      ),
      filters: [
        { text: "Creada", value: "creada" },
        { text: "Devuelta", value: "devuelta" },
     
      ],
      onFilter: (value, record) => record.estado === value,
    },
    {
      title: "# Productos",
      dataIndex: "productos",
      key: "productos",
      render: (productos) => productos?.length || 0,
    },
    {
      title: "# Seriales",
      key: "seriales",
      render: (_, record) => {
        return serialCounts[record.id] || 0;
      },
    },
    {
      title: "Total",
      key: "total",
      render: (_, record) => {
        const total = calculateTotals(record.productos);
        return `${formatPrice(total.total, signoMoneda)}`;
      },
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => (
        <Space direction="horizontal" size="large">
       <Button type="primary" onClick={() => showFacturaDetails(record)}>
          Ver detalles
        </Button>
        <Button onClick={()=> console.log("descargar factura fiscal")
        }>Descargar Factura Fiscal</Button>   
        </Space>
        
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={facturas}
      rowKey="id"
      loading={loading}
      pagination={false}
    />
  );
};

export default InvoiceTable;
